var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.form
    ? _c(
        "form",
        {
          staticClass: "registration-form",
          attrs: { action: _vm.action, method: "POST" }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "_token" },
            domProps: { value: _vm.csrkToken }
          }),
          _vm._v(" "),
          _c(
            "md-card",
            { staticClass: "profil-form profil-form-data" },
            [
              _c("md-card-header", [
                _c("h2", {
                  staticClass: "md-title md-title-dark",
                  domProps: { innerHTML: _vm._s(_vm.title) }
                })
              ]),
              _vm._v(" "),
              _c("md-card-content", [
                _c("div", { staticClass: "form-row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "entity-type-container",
                      class: { "md-invalid": !!_vm.errors.entity_type }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.entityTypeSelectionLabel) + " : *")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "flex" }, [
                        _c(
                          "div",
                          { staticClass: "flex items-center" },
                          [
                            _c("md-radio", {
                              attrs: { value: "company" },
                              model: {
                                value: _vm.fData.entity_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.fData, "entity_type", $$v)
                                },
                                expression: "fData.entity_type"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("registration.want-to-fly-pro"))
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "ml-20 flex items-center" },
                          [
                            _c("md-radio", {
                              attrs: { value: "individual" },
                              model: {
                                value: _vm.fData.entity_type,
                                callback: function($$v) {
                                  _vm.$set(_vm.fData, "entity_type", $$v)
                                },
                                expression: "fData.entity_type"
                              }
                            }),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("registration.want-to-fly-private")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "md-error" }, [
                        _vm._v(
                          _vm._s(
                            _vm.errors.entity_type
                              ? _vm.errors.entity_type[0]
                              : ""
                          )
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.fData.entity_type == "company"
                  ? _c(
                      "div",
                      { staticClass: "form-row" },
                      [
                        _c(
                          "md-field",
                          { class: { "md-invalid": !!_vm.errors.entity_name } },
                          [
                            _c("label", [
                              _vm._v(_vm._s(_vm.$t("registration.entity-name")))
                            ]),
                            _vm._v(" "),
                            _c("md-input", {
                              attrs: {
                                type: "text",
                                name: "entity_name",
                                disabled: _vm.submitting ? "disabled" : null,
                                dusk: "entity-name-input"
                              },
                              model: {
                                value: _vm.fData.entity_name,
                                callback: function($$v) {
                                  _vm.$set(_vm.fData, "entity_name", $$v)
                                },
                                expression: "fData.entity_name"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "md-error",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.errors.entity_name
                                    ? _vm.errors.entity_name[0]
                                    : ""
                                )
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "md-field",
                        { class: { "md-invalid": !!_vm.errors.lastname } },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("registration.lastname")))
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: {
                              name: "lastname",
                              disabled: _vm.submitting ? "disabled" : null,
                              required: ""
                            },
                            model: {
                              value: _vm.fData.lastname,
                              callback: function($$v) {
                                _vm.$set(_vm.fData, "lastname", $$v)
                              },
                              expression: "fData.lastname"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errors.lastname
                                  ? _vm.errors.lastname[0]
                                  : ""
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "md-field",
                        { class: { "md-invalid": !!_vm.errors.firstname } },
                        [
                          _c("label", [
                            _vm._v(_vm._s(_vm.$t("registration.firstname")))
                          ]),
                          _vm._v(" "),
                          _c("md-input", {
                            attrs: {
                              name: "firstname",
                              disabled: _vm.submitting ? "disabled" : null,
                              required: ""
                            },
                            model: {
                              value: _vm.fData.firstname,
                              callback: function($$v) {
                                _vm.$set(_vm.fData, "firstname", $$v)
                              },
                              expression: "fData.firstname"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "md-error" }, [
                            _vm._v(
                              _vm._s(
                                _vm.errors.firstname
                                  ? _vm.errors.firstname[0]
                                  : ""
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c(
                      "md-field",
                      { class: { "md-invalid": !!_vm.errors.entity_type } },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$t("registration.job-label")))
                        ]),
                        _vm._v(" "),
                        _c(
                          "md-select",
                          {
                            attrs: {
                              name: "role",
                              dusk: "entity-type-input",
                              disabled: _vm.submitting ? "disabled" : null
                            },
                            model: {
                              value: _vm.fData.role,
                              callback: function($$v) {
                                _vm.$set(_vm.fData, "role", $$v)
                              },
                              expression: "fData.role"
                            }
                          },
                          _vm._l(_vm.userRoles, function(role) {
                            return _c(
                              "md-option",
                              { key: role.key, attrs: { value: role.id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(role.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "md-error" }, [
                          _vm._v(
                            _vm._s(_vm.errors.role ? _vm.errors.role[0] : "")
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-row" },
                  [
                    _c("city-input", {
                      attrs: {
                        "no-icon": "",
                        name: "city_id",
                        label: _vm.$t("registration.your-city"),
                        "no-label": true,
                        "city-name": _vm.fData["city_name"],
                        "input-error": _vm.errors["city_id"],
                        disabled: _vm.submitting ? "disabled" : null,
                        dusk: "city-input"
                      },
                      model: {
                        value: _vm.fData["city_id"],
                        callback: function($$v) {
                          _vm.$set(_vm.fData, "city_id", $$v)
                        },
                        expression: "fData['city_id']"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-row",
                    class: { "mt-35": !!_vm.errors.email }
                  },
                  [
                    _c("phone-field", {
                      ref: "phoneInput",
                      attrs: {
                        required: "",
                        name: "phone",
                        errors: _vm.errors.phone,
                        label: _vm.$t("registration.mobile"),
                        "mobile-only": "",
                        "country-id": _vm.countryId,
                        disabled: _vm.submitting ? "disabled" : null
                      },
                      model: {
                        value: _vm.fData.phone,
                        callback: function($$v) {
                          _vm.$set(_vm.fData, "phone", $$v)
                        },
                        expression: "fData.phone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-row form-row-submit" }, [
                  _c(
                    "div",
                    { staticClass: "form-submit-button" },
                    [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("registration.accept-tos"))
                        }
                      }),
                      _vm._v(" "),
                      _c("submit-button", {
                        staticClass: "registration-standalone-button",
                        attrs: {
                          type: "submit",
                          submitting: _vm.submitting,
                          label: _vm.$t("registration.create_account"),
                          dusk: "submit-profile-button"
                        },
                        on: {
                          click: function($event) {
                            _vm.onSubmit()
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0ada93a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0ada93a","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formData.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-d0ada93a","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/formData.vue
// module chunks = 1 2 3